export function DataDeletion() {
  return (
    <div style={{ minHeight: '100vh', background: '#ffffff', color: '#111827' }}><div style={{ maxWidth: 680, margin: '0 auto', padding: '48px 24px', fontFamily: 'system-ui, sans-serif', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Eliminación de Datos</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 32 }}>Última actualización: mayo 2026</p>

      <p>Si iniciaste sesión en Proclaim con tu cuenta de Facebook o Google y deseas que eliminemos tu información, puedes solicitarlo de cualquiera de estas formas:</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>Opción 1 — Correo electrónico</h2>
      <p>Envía un correo a <a href="mailto:germanisaicreative@gmail.com" style={{ color: '#E00035' }}>germanisaicreative@gmail.com</a> con el asunto <strong>&ldquo;Solicitud de eliminación de datos&rdquo;</strong> e indica el correo asociado a tu cuenta. Procesamos la solicitud en un máximo de 7 días hábiles.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>Opción 2 — Desde la aplicación</h2>
      <p>Si tienes acceso a tu cuenta, puedes eliminarla directamente desde <strong>Configuración → Cuenta → Eliminar cuenta</strong> dentro de la aplicación. Esto borrará toda tu información de forma inmediata e irreversible.</p>

      <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 32, marginBottom: 8 }}>¿Qué datos se eliminan?</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li>Nombre y dirección de correo electrónico.</li>
        <li>Historial de sesiones e información de autenticación.</li>
        <li>Asociación con tu organización (iglesia o grupo).</li>
      </ul>
      <p>El contenido de la organización (presentaciones, canciones) <strong>no</strong> se elimina al borrar un usuario individual; corresponde al administrador de la organización gestionarlo.</p>

      <p style={{ marginTop: 48, color: '#9ca3af', fontSize: 13 }}>© {new Date().getFullYear()} Proclaim · Todos los derechos reservados</p>
    </div></div>
  );
}
